/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  ExtendedFlex,
  Link,
  Body,
  Tooltip,
  TooltipLink,
} from '../../coreui';

import DistributionsToggle from './DistributionsToggle';

const ReitButtons = ({
  id,
  dripToggleDisabled,
  reinvestDistributionsURL,
  receiveCashDistributionsURL,
  distributionReinvestmentPlanUrl,
  distributionReinvestmentPlanTooltip,
  smartButtonUrl,
  smartButtonText,
  smartButtonMessageText,
  dripSetting,
  invested,
  title,
}) => {
  return (
    <ExtendedFlex
      width={1}
      mt={[0, 50]}
      mb={10}
      flexDirection={['column']}
    >
      <ExtendedFlex
        width={['100%', 'auto']}
        flexDirection={['column', 'row']}
        flexWrap="wrap"
        align="flex-start"
      >
        <ExtendedFlex
          flexDirection="column"
          w={[1, 'auto']}
          flexBasis="60%"
        >
          <DistributionsToggle
            id={id}
            reinvestDistributionsURL={reinvestDistributionsURL}
            receiveCashDistributionsURL={receiveCashDistributionsURL}
            dripSetting={dripSetting}
            isDisabled={dripToggleDisabled ? true : !invested}
          />
          <Body
            type="B3"
            my="0"
            mt={[10, 10]}
          >
            {
              !invested &&
              `You can manage ${title} distributions here when you invest.`
            }
            {
              invested && dripSetting &&
              'Your distributions will be reinvested.'
            }
            {
              invested && !dripSetting &&
              'You will receive cash distributions.'
            }
          </Body>
          <ExtendedFlex
            my={[10, 10]}
            order={[0, 1]}
          >
            <TooltipLink
              type="L4"
              tooltipId={`driptooltip:${id}`}
              {...(distributionReinvestmentPlanUrl ? {
                href: distributionReinvestmentPlanUrl,
              } : {})}
            >
              Distribution Reinvestment Plan
            </TooltipLink>
            {
              distributionReinvestmentPlanTooltip &&
              <Tooltip id={`driptooltip:${id}`}>
                <Body type="B5">
                  {distributionReinvestmentPlanTooltip}
                </Body>
              </Tooltip>
            }
          </ExtendedFlex>
        </ExtendedFlex>
        {
          smartButtonUrl &&
          <ExtendedFlex
            ml={[null, 'auto']}
            my={[40, 0]}
            justify={['flex-start', 'flex-end']}
            alignItems="center"
            w={[1, 'auto']}
            flexBasis={['100%', '40%']}
          >
            <ExtendedFlex
              flexDirection="column"
              align={['flex-start', 'flex-end']}
              w={[1, 'auto']}
            >
              <ExtendedBox
                w={[1, 'auto']}
              >
                <Link
                  type="L1"
                  width={['100%', 'auto']}
                  href={smartButtonUrl}
                  maxWidth={null}
                >
                  {smartButtonText}
                </Link>
              </ExtendedBox>
              {
                smartButtonMessageText &&
                <Body
                  type="B3"
                  textAlign={['left', 'right']}
                >
                  {smartButtonMessageText}
                </Body>
              }
            </ExtendedFlex>
          </ExtendedFlex>
        }
      </ExtendedFlex>
    </ExtendedFlex>
  );
};

ReitButtons.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dripToggleDisabled: PropTypes.bool,
  reinvestDistributionsURL: PropTypes.string,
  receiveCashDistributionsURL: PropTypes.string,
  distributionReinvestmentPlanUrl: PropTypes.string,
  distributionReinvestmentPlanTooltip: PropTypes.node,
  smartButtonUrl: PropTypes.string,
  smartButtonText: PropTypes.string,
  smartButtonMessageText: PropTypes.string,
  invested: PropTypes.bool,
  title: PropTypes.string,
  dripSetting: PropTypes.bool,
};

export default ReitButtons;
